const autoPlayVideos = () => {
    // Logic for Autoplay videos
      const sPageURL = decodeURIComponent(window.location.search.substring(1));
      const sURLVariables = sPageURL.split('&');
      const vars = [];
      const sSelector = 'a.js-magnific-video.autoplay-on';
  
      // let $autoPlay;
      let $toggle;
  
      vars.autoplay = sURLVariables[0].split('=');
      const $autoPlay = vars.autoplay[1] === undefined ? false : vars.autoplay[1];
  
      if (sURLVariables.length > 1) {
          vars.video = sURLVariables[1].split('=');
          $toggle = vars.video[1];
      }
  
      if ($autoPlay[1]) {
        if (sURLVariables.length > 1 && vars.video[0] === 'video') {
            document.getElementById($toggle).click();
        } else {
            document.querySelector(sSelector).click();
        }
    }
  
      // console.log(vars + ' toggle: ' + $toggle + ' sSelector :' + sSelector + ' param: ' + vars.video[0]);
  }
  
  $(document).ready(() => {
    autoPlayVideos();
  });